import { render, staticRenderFns } from "./popup_participation_details.vue?vue&type=template&id=3b48fbab&"
import script from "./popup_participation_details.vue?vue&type=script&lang=js&"
export * from "./popup_participation_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports